import React, { useState } from "react";
import styles from "./AboutMe.module.css";
import ProjectGrid from "./ProjectGrid";
import SectionHeader from "./SectionHeader";
import PortfolioFooter from "./PortfolioFooter";

const filters = [
  { label: "React Native", value: "React Native" },
  { label: "Flutter", value: "Flutter" },
  { label: "Android", value: "Android" },
  { label: "Other", value: "Other" },
];

function LinkSection({
  filter,
  setFilter,
}: {
  filter: string | undefined;
  setFilter: (f: string | undefined) => void;
}) {
  return (
    <div className={styles["about-skills"]}>
      {filters.map((f) => (
        <button
          key={f.value}
          className={styles["skill-badge"]}
          style={{
            background: filter === f.value ? "#2563EB" : undefined,
            color: filter === f.value ? "#fff" : undefined,
            border: filter === f.value ? "1px solid #2563EB" : undefined,
          }}
          onClick={() => setFilter(filter === f.value ? undefined : f.value)}
        >
          {f.label}
        </button>
      ))}
    </div>
  );
}

export default function AboutMe() {
  const [filter, setFilter] = useState<string | undefined>(undefined);

  return (
    <>
      <section id="about" className={styles["about-section"]}>
        <div className={styles["about-section-header"]}>
          <SectionHeader title="About Me" />
        </div>
        <div className={styles["about-container"]}>
          <img
            src="/me.jpg"
            alt="Developer portrait"
            className={styles["about-photo"]}
          />
          <div style={{ flex: 1 }}>
            <LinkSection filter={filter} setFilter={setFilter} />
            <p className={styles["about-bio"]}>
              Hi! I'm John, a senior React Native developer with a passion for
              building high-quality, cross-platform mobile apps. I enjoy working
              with modern technologies to deliver seamless user experiences on
              Android, iOS, and beyond.
            </p>
          </div>
        </div>
      </section>
      <ProjectGrid filter={filter} />
    </>
  );
}
